/**
 * playerConfigStorage — acesso leve à config do player persistida localmente.
 * ==========================================================================
 *
 * Fonte única da chave `efflux_player_config` (volume/brilho/alertas etc). Mantida
 * fora do {@link ConfigManager} pra poder ser lida por módulos que não devem
 * arrastar as dependências pesadas do componente (ex.: o bootstrap do canal
 * embedded, no `releaseVolume` do host-owned volume).
 */

/** Chave do localStorage onde o ConfigManager persiste a config do player. */
export const CONFIG_KEY = 'efflux_player_config';

/**
 * Volume (0-100) da última config do servidor persistida, ou undefined se não
 * houver / storage indisponível. Usado pelo canal embedded no `releaseVolume`
 * pra reaplicar o volume vigente do servidor ao devolver o controle a ele.
 */
export function readStoredServerVolume(): number | undefined {
  try {
    const raw = localStorage.getItem(CONFIG_KEY);
    if (!raw) return undefined;
    const cfg = JSON.parse(raw) as { volumeLevel?: number };
    return typeof cfg.volumeLevel === 'number' ? cfg.volumeLevel : undefined;
  } catch {
    return undefined;
  }
}
